import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** 大數縮寫：>= 10,000 顯示 42k，>= 1,000,000 顯示 1.5m；其餘原樣 */
export function fmtKpi(n: number): string {
  if (n >= 1_000_000) {
    const v = Math.round(n / 100_000) / 10
    return (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)) + 'm'
  }
  if (n >= 10_000) return Math.round(n / 1_000) + 'k'
  return n.toLocaleString()
}
